var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.msg)?_c('div',{staticClass:"loader-container",class:_vm.variant},[(typeof _vm.msg === 'string')?_c('div',{staticClass:"msg"},[_vm._v(_vm._s(_vm.msg))]):_vm._e(),_c('div',{staticClass:"loader"})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }